import { render, staticRenderFns } from "./ProductItemIndex.vue?vue&type=template&id=72f59aae&"
import script from "./ProductItemIndex.vue?vue&type=script&lang=js&"
export * from "./ProductItemIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports